import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";



function GatchamonRules() {
  return (
    <Layout>
      <div className="space-y-6 font-gillsans mb-12">
        <Helmet>
          <title>Règles du Super Gatchamon | Croquette</title>
        </Helmet>
        <p className="text-5xl font-bold text-blue-600 mb-8">
          Règles
        </p>

        <p className="text-3xl font-bold text-blue-600 mb-8">Les termes</p>

        <p><u><b>Inventaire</b></u>: C'est un espace à la fin de votre classeur. Vous pourrez y stocker les items obtenus au cours de votre aventure.</p>
        <p><u><b>Deck</b></u>: Il s'agit de la pioche face cachée. Vous ne pourrez jamais regarder les cartes à l'intérieur, seulement les piocher.</p>
        <p><u><b>Pokédex</b></u>: C'est l'espace au début de votre classeur. Lorsque vous piochez un Pokémon pour la première fois, ajoutez-le à votre Pokédex. L'objectif est de capturer les 151 Pokémon de la Première Génération. Quand un Pokémon est placé dans votre Pokédex, il y reste.</p>
        <p><u><b>Stock</b></u>: Le Stock est le paquet d'enveloppes. Les enveloppes contiennent des cartes. Vous pouvez lire ce qui est écrit dessus, mais pas les ouvrir sans y être invité.</p>
        <p><u><b>Boîte PC</b></u>: C'est une boite où vous gardez vos Pokémon en double. Cet endroit est séparé de votre Pokédex. Laissez les Pokémon de la Boîte PC sous protège-cartes.</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">Commencer à jouer</p>

        <p>Choisissez un Pokémon de départ. Les choix sont Bulbizarre, Carapuce et Salamèche. Le Pokémon choisi sera le premier de votre Pokédex. Placez-le dans votre classeur, et mélangez les 2 autres à votre deck.</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">Les cartes sont des récompenses</p>

        <p>Le Super Gatchamon a été créé dans le but de se motiver à faire des tâches pas forcément joyeuses. Par exemple, dans mon cas, ça serait faire 20 min de sport, préparer un super repas, ou encore ranger et désinfecter mon bureau.</p>

        <p>À chaque fois que vous finissez une tâche, piochez une carte. Perso je pense piocher environ 5 cartes par jour si je travaille bien, mais chacun fait comme il le sens. C'est aussi une question d'effort, et pas seulement de résultats. Bref faites comme vous le sentez mais ne tirez pas 2 cartes d'un coup, ça ruinera votre expérience.</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">Piocher des cartes</p>

        <p>Il y a 3 types de cartes que vous pouvez piocher:</p>

        <ul className="list-disc list-inside">
          <li>Un Nouveau Pokémon</li>
          <li>Un Pokémon que vous avez déjà</li>
          <li>Une carte qui n'est pas un Pokémon</li>
        </ul>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Attraper un Nouveau Pokémon</p>

        <p>Lorsque vous piochez un Pokémon que vous n'avez pas dans votre Pokédex, ajoutez-le à votre Pokédex.</p>

        <p>Dans ce cas, mélangez le contenu de votre Boîte PC à votre deck, à l'exception de Minidraco et de Draco. Toutes les cartes Pokémon mélangées doivent être sleevées face verso (comme le reste du deck).</p>

        <p>⚠️ Exception ⚠️ Si vous utilisez une Pierre d'Évolution ou un Échange, vous n'aurez pas besoin de mélanger votre Boîte PC à votre deck.</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Attraper un Doublon</p>

        <p>Lorsque vous piochez un Pokémon que vous avez déjà, placez-le dans votre Boîte PC.</p>

        <p>Si le Pokémon peut évoluer, regardez votre Stock d'Évolutions. Si vous y trouvez l'enveloppe correspondant à son évolution, déclenchez-la: prenez le contenu de l'enveloppe, et mélangez-le à votre deck.</p>

        <p>L'évolution de votre Pokémon est à présent attrapable.</p>

        <p>Note: Le Pokémon pioché initialement reste dans la Boîte PC lors de l'évolution.</p>

        <p>⚠️ Exception ⚠️ Minidraco et Draco nécéssitent d'obtenir 3 exemplaires pour évoluer, et non 2 comme les autres Pokémons.</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Piocher une carte autre qu'un Pokémon</p>

        <p>Si la carte que vous piochez n'est pas un Pokémon, lisez-la et appliquez l'effet.</p>

        <p> Il se peut que vous puissiez garder la carte. Dans ce cas, placez-la dans votre inventaire.</p>

        <p>Si vous piochez une carte Énergie, placez-la dans votre inventaire et consultez votre Stock de Quêtes.</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">Détail du Stock</p>

        <p>Le Stock est composé de 3 types d'enveloppes:</p>

        <ul className="list-disc list-inside font-gillsans">
          <li>Les Évolutions</li>
          <li>Les Quêtes</li>
          <li>Les Autres Ajouts</li>
        </ul>

        <p>Note: Une fois une enveloppe vidée, placez-là hors du jeu. Elle pourra potentiellement resservir pour un futur Gatchamon, qui sait?</p>


        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Les Évolutions</p>

        <p>Ce sont les enveloppes qui seront rajoutées au deck lors d'une évolution. Ces enveloppes sont labellées "EV" en bleu marine. Pour plus de détails, lisez la section "Attraper un Doublon".</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Les Quêtes</p>

        <p>Certaines enveloppes de votre Stock sont labellées "QUEST" en orange. Ce sont des Quêtes. Lisez les inscriptions de ces enveloppes de temps en temps. Une fois que vous réussissez une quête, vous pouvez mélanger le contenu de l'enveloppe correspondante à votre deck.</p>

        <p className="text-xl font-bold text-blue-600 mb-8 !mt-12">Les Autres Ajouts</p>

        <p>Certaines enveloppes de votre Stock ne sont ni des Évolutions, ni des Quêtes. Il s'agit des Autres Ajouts. Leurs labels sont bleus clair. Les Autres Ajouts n'ont aucun indice sur comment débloquer le contenu des enveloppes. Faites confiance au Gatchamon.</p>

        <p className="text-3xl font-bold text-blue-600 mb-8 !mt-12">
          FAQ
        </p>

        <div>
          <p><b>Q</b> - J'ai pioché une énergie, que dois-je faire?</p>
          <p><b>A</b> - Bien joué! Vous avez progressé sur une quête! Vous pouvez lire ce qui est écrit sur l'extérieur des enveloppes à tout moment. Gardez cette énergie dans votre inventaire.</p>
          <br/>
          <p><b>Q</b> - Est-ce que je peux acheter plusieurs Pokémon si j'ai suffisamment de jetons lorsque je tire la carte Game Corner?</p>
          <p><b>A</b> - Non, il faudra attendre de piocher Game Corner une seconde fois pour acheter un second Pokémon</p>
          <br/>
          <p><b>Q</b> - Je veux mélanger une Safari Ball additionnelle au deck, mais il n'y en a plus en Stock, que faire?</p>
          <p><b>A</b> - Si vous n'avez plus de cartes Safari Ball de disponible, vous ne pouvez pas mélanger de Safari Ball additionnelle au deck.</p>
          <br/>
          <p><b>Q</b> - J'ai mélangé le Minidraco ou Draco qui était dans ma Boîte PC à mon deck! Est-ce que je peux le récupérer?</p>
          <p><b>A</b> - Il est impossible de récupérer des cartes du deck autrement qu'en les piochant. Il va falloir piocher 2 Minidraco/Draco pour le faire évoluer.</p>
          <br/>
          <p><b>Q</b> - Quand on achète un Pokémon au Game Corner, est-ce qu'on le met dans notre deck, ou dans notre pokédex?</p>
          <p><b>A</b> - Directement dans le pokédex</p>
          <br/>
          <p><b>Q</b> - Si j'achète Minidraco au Game Corner, je vais donc l'ajouter à mon Pokédex. Est-ce que je mélange les 2 autres Minidraco à mon deck?</p>
          <p><b>A</b> - Non, il faut laisser les 2 autres Minidraco à leur place. Tu pourras en acheter un nouveau la prochaine fois que tu pioches la carte Game Corner, ou si tu as de la chance dans le safari :)</p>
        </div>
        <br/>
        <br/>
        <p className="text-s italic text-blue-600 mb-8 !mt-12">Last updated 12/09/2025 09:16</p>
        <br/>
        <br/>
        <br/>
      </div>
    </Layout>
  );
}

export default GatchamonRules;
